:host {
  position: absolute;
  inset: 0;
  display: block;
  overflow: hidden;
  pointer-events: none;
  opacity: var(--ds-paper-texture-opacity, 1);
}

.paper-texture__mount {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  isolation: isolate;
}

.paper-texture__mount[data-paper-shader] canvas {
  z-index: 0;
}

:host([data-paper-texture-error]) {
  display: none;
}
